module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'media'
	],

	config: {
		listComponentClass: 'base_mediaManagement_image_imageList',
		listElementComponentClass: 'base_form_media_image_image',
		nrOfElementsComponentClass: 'base_mediaManagement_image_nrOfElements',
		listNewElementContainerClass: '.newImages',
		getCategorizedMediaActionName: 'getCategorizedMedia'
	},

	methods: {
		dataDealer: function () {
			this.model.fieldConfig = this.getResourceRegisterContent('fieldConfig') || {}
			this.model.managementConfig = this.model.fieldConfig.managementConfig || {}
		}
	}
}